import {Routes, Route, useParams, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";

import {UsePost, UsePut} from "../../hooks/http";
import {countPropsWithPrefix} from "../../helpers/object";
import {renderToStaticMarkup} from "@usewaypoint/email-builder";
import {useDocument, useHtml, usePlain} from "../../modules/email-editor/documents/editor/EditorContext";
import {Editor} from "./Editor";
import Listing from "./Listing";
import {ManagerContext} from "./ManagerContext";
import {fetchDomains, fetchEnterprises, fetchSenders} from "../enterprises/api";
import {UseMessage} from "../../hooks/UseMessage";


const EmailManager = () => {

    const {id} = useParams()
    const navigate = useNavigate();

    const [email, setEmail] = useState()
    const [errors, setErrors] = useState()

    const [domains, setDomains] = useState()
    const [senders, setSenders] = useState()
    const [enterprises, setEnterprises] = useState()

    const [subject, setSubject] = useState()
    const [replyTo, setReplyTo] = useState()
    const [senderName, setSenderName] = useState()
    const [currentDomain, setCurrentDomain] = useState()
    const [currentSender, setCurrentSender] = useState()
    const [currentEnterprise, setCurrentEnterprise] = useState()

    const [editorKey, setEditorKey] = useState(0);
    const [isLoading, setIsLoading] = useState(true)

    const html = useHtml();
    const plain = usePlain();
    const document = useDocument();


    const onSave = async () => {
        const code = renderToStaticMarkup(document, {rootBlockId: 'root'});
        const editor = countPropsWithPrefix(document, 'block') > 0 ? code : null


        const payload = {
            origin : {
                id_enterprise: currentEnterprise,
                id_domain    : currentDomain,
                id_sender    : currentSender,
                sender_name  : senderName,
                reply_to     : replyTo
            },
            content: {
                charset      : 'UTF-8',
                subject, html: html ?? null,
                plain        : plain ?? null,
                editor,
                document     : JSON.stringify(document)
            },
        }


        setIsLoading(true)
        const response = await UsePost(
            `/emails/upsert/${id || ''}`,
            {data: payload}, {showMessage: false}
        );

        setErrors(response.code < 200 || response.code > 299 ? response.errors : undefined)
        setIsLoading(false)

        if (response.code >= 200 && response.code < 300) {
            setEditorKey(prev => prev + 1);
            UseMessage(
                'success',
                `Email has been successfully ${id ? 'updated' : 'created'}`,
                'toast-bottom-right'
            )
            navigate(`/emails/${response.id}`)
        }
    }


    const initEnterprises = async () => {
        let formated = [];
        const enterprises = await fetchEnterprises();


        if (enterprises?.length > 0) {
            formated = enterprises.map(item => (
                {value: item._id.$oid, label: item.name}
            ))
        }

        setEnterprises(formated)
    }


    const initEmail = async () => {
        if (id && id !== 'new') {
            const email = await UsePut(
                `/emails/get/${id}`,
                {data: {limit: 1, offset: 0, _id: id}}
            )

            setEmail(email?.entities?.[0])
            setSenderName(email?.entities?.[0]?.origin?.sender_name)
            setReplyTo(email?.entities?.[0]?.origin?.reply_to)
            setSubject(email?.entities?.[0]?.content?.subject)
            setCurrentEnterprise(email?.entities?.[0]?.origin?.id_enterprise?.$oid)
            setCurrentDomain(email?.entities?.[0]?.origin?.id_domain?.$oid)
            setCurrentSender(email?.entities?.[0]?.origin?.sender_name)
            setCurrentSender(email?.entities?.[0]?.origin?.id_sender?.$oid)


        } else {
            setEmail(undefined)
        }
    }


    const initDomains = async () => {
        let formated = [];
        if (currentEnterprise) {
            const domains = await fetchDomains(currentEnterprise);
            if (domains?.length > 0) {
                formated = domains.map(item => (
                    {value: item._id.$oid, label: item.name}
                ))
            }
        }
        setDomains(formated)
    }


    const initSenders = async () => {
        let formated = [];

        if (currentDomain) {
            const senders = await fetchSenders(currentDomain);

            if (senders?.length > 0) {
                formated = senders.map(item => (
                    {value: item._id.$oid, label: `${item.name} <${item.email}>`}
                ))
            }
        }
        setSenders(formated)
    }


    useEffect(() => {
        const fetchData = async () => {
            await initEnterprises();
            await initEmail();
        }

        void fetchData();
        setErrors(undefined)
        setIsLoading(false)

    }, [id, editorKey]);


    useEffect(() => {
        const fetchData = async () => {
            await initDomains()
        }

        void fetchData();
    }, [currentEnterprise]);


    useEffect(() => {
        const fetchData = async () => {
            await initSenders()
        }

        void fetchData();
    }, [currentDomain]);


    return (
        <Routes>
            <Route index element={<Listing/>}/>
            <Route path=":mode" element={
                <ManagerContext.Provider
                    value={{
                        email, enterprises, domains, senders, errors, isLoading, setIsLoading,
                        currentEnterprise, currentDomain, currentSender, senderName, replyTo, subject,
                        setCurrentEnterprise, setCurrentDomain, setCurrentSender, setSenderName, setReplyTo, setSubject,
                        onSave
                    }}>
                    <Editor/>
                </ManagerContext.Provider>
            }/>
        </Routes>
    )
}

export default EmailManager